export default __webpack_public_path__ + "static/media/plane.9aec99fb.png";